import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { getLatestDateFromData } from "../../../Utils/utils";
import Loader from "../../../components/Loader";

const LiaisonOfficerTab = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: liaisonOfficerData = [], isLoading: liaisonOfficerIsLoading } =
    useGetProtectedApiDataQuery({ url: "liaison-officer", lang: languageType });

  // page last updated on
  const lastUpdatedOn = getLatestDateFromData(liaisonOfficerData);

  if (liaisonOfficerIsLoading) {
    return <Loader />;
  }
  return (
    <>
      <section aria-labelledby="liaison-officer-heading">
        <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
        <div className="director-section">
          <div className="container">
            <h2 id="liaison-officer-heading" className="sr-only">
              Liaison Officer Information
            </h2>
            <div
              dangerouslySetInnerHTML={{
                __html: liaisonOfficerData[0]?.body,
              }}
              aria-live="polite"
            ></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LiaisonOfficerTab;
